import { render, staticRenderFns } from "./LicenseHandler.vue?vue&type=template&id=d69bb5c2&scoped=true"
import script from "./LicenseHandler.vue?vue&type=script&lang=js"
export * from "./LicenseHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69bb5c2",
  null
  
)

export default component.exports